export const routes = {
  root: "/",
  login: "/login",
  report: "/report",
  profile: "/profile",
  wefundingDemo: "wefunding-demo",
  admin: "/admin",
  dashboard: "/dashboard",
};
